import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { fetchArticles, setActiveArticle } from '../slices/coreAssetsSlice'

import { Container, Grid, Image, Popup } from "semantic-ui-react"
import { ContentFetcher } from '../utils/contentFetcher';

// import { authoratorTitle } from '../utils/auth-title-name'
import '../styles/article.css'
// import authorEntersTheGreatAuthoratorTemple from '../assets/author_undertakes_the_path_of_creation.png'
import infoTornado from '../assets/shutterstock_2294406661_circle.png'
import useIsLoggedIn from '../isLoggedIn';
import ArticleSlider from '../components/aaiArticleSidebar'
import { AuthStdFooter } from "../utils/auth-std-footer"



// const demoList = [{
//   articleItemUuid: '5687de9a-cb31-efb4-d917-fafc734ccabc',
//   heroImgUrl: "https://awethorator.com/wp-content/uploads/2023/05/shutterstock_2294394255-1024x1024.png",
//   blgLstTitle: "A Title here Dude",
//   author: "E.T. Ellison",
//   date: new Date().toLocaleTimeString(),
//   category: 'tutorial',
//   content: "First, do the first thing. Then do the second thing...and keep on until done. And then, do it more, and more. Never end. Just keep making things until your mind and life are spent. After saying that, you must be happy when you get to the end of your live and this is your condition. You really have to go the distance to force and elipsis example."
// },
// {
//   articleItemUuid: '1e9e8fff-13c2-803a-e06a-1ae92873bbfe',
//   heroImgUrl: authorEntersTheGreatAuthoratorTemple,
//   blgLstTitle: "Author's process teachings",
//   author: "E.T. Ellison",
//   date: new Date().toLocaleTimeString(),
//   category: 'tutorial',
//   content: "An Author motivates into audiobook creation..."
// }];

export default function Article(activeArticle) {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  let articleListOptions = useRef([{ key: 'noitems', text: "Article Item", value: 'noitems', data: {} }])
  const articleList = useSelector((state) => {
    // console.log('allArticles', state.core.articles.articles);
    if (state.core.articles.articles) {
      articleListOptions.current = state.core.articles.articles.map((x) => {
        let key_value = x.name.replace(/[^a-z0-9]/gi, '').toLowerCase()
        return { key: key_value, text: x.name, value: key_value, data: x }
      })
      // console.log('allArticles', articleListOptions);

    }
    return state.core.articles.articles;
  })
  let currentArticleUuid = useRef(null)
  const authToken = useIsLoggedIn();

  useEffect(() => {
    let props = { uuid: '2cc388cb-ae96-3edb-1136-14c1b0c0324d', reqCategories: "" }
    dispatch(fetchArticles(props))
      .unwrap()
      .then((data) => {
        // handle success here
        // console.log('success articles fetch', data)
      })
      .catch((error) => {
        // handle error here
        // console.log('failed articles fetch', error.message)

      });

  }, [dispatch, authToken])


  useEffect(() => {
    // console.log('Article', articleList)
  }, [articleList])

  useEffect(() => {
    console.log('Article activeArticle', activeArticle)
  }, [activeArticle])

  const setActiveArticleHandler = (articleUuid) => {
    console.log('setActiveArticle', articleUuid)
    if (currentArticleUuid.current !== articleUuid) {
      currentArticleUuid.current = articleUuid;
      navigate(`/articleItemContainer/${articleUuid}`);
      dispatch(setActiveArticle(articleUuid));

    }

  }
  const articleListItem = (index, articleItemUuid, heroImgUrl, blgLstTitle, author, date, category, contentUrl, excerpt) => {
    return (
      <Grid.Row key={index.toString()}>
        <Grid.Column width={3} >
          <div className="selector" onClick={() => {
            setActiveArticleHandler(articleItemUuid)
          }}>

            <Image src={heroImgUrl} />

          </div>
        </Grid.Column>
        <Grid.Column width={13}>
          {/* <Link to={`/articleItemContainer/${articleItemUuid}`} > */}
          <div className="selector" onClick={() => {
            setActiveArticleHandler(articleItemUuid)
          }}>
            <span className="blgListItemTitle mediumTitleSize">{blgLstTitle}</span><br />
            <span className="blgListAuthor">{`by ${author} | ${date} | ${category.toUpperCase()}`}</span>
            <Popup
              basic
              wide='very'
              offset={[-8]}
              content={<ContentFetcher url={contentUrl} length={150} />}
              key={`charPopup-${index.toString()}`}
              header={blgLstTitle}
              // trigger={<p className="blgListContent multiline-ellipsis">{excerpt}</p>}
              trigger={<p className="blgListContent multiline-ellipsis">{excerpt}</p>}

            />
          </div>
          {/* </Link> */}
        </Grid.Column>
      </Grid.Row>
    )
  }

  const fillList = () => {
    return (
      articleList && articleList.map((articleItem, index) => {
        // console.log('articleItem', articleItem)
        const { uuid, thumbnailImageUrl, name, author, updatedOn, categories, contentUrl, excerpt } = articleItem;
        return articleListItem(index, uuid, thumbnailImageUrl, name, author, updatedOn, categories[0], contentUrl, excerpt)
      })
    )
  }

  const articlePage = () => {
    return (
      <>
        <div className="std-pg-main-area std-pg-grey-background-color" style={{ marginBottom: "70px" }} >
          <Container style={{ marginTop: "30px", marginBottom: "200px" }}>
            <Grid className="articleListWidth">
              <Grid.Row>
                <Grid.Column width={3} >
                  <div className="img-with-gradient">
                    <Image src={infoTornado} />
                  </div>

                </Grid.Column>
                <Grid.Column width={13} textAlign="center">
                  <span className="blgListItemTitle">Authorator Information</span>
                  <span className="blgListSubTitle">Ways and Whys</span>
                  <div className="centerTextBlock" style={{ paddingTop: "10px" }}>
                    <p className="blgListHeadingContent">
                      Check here to learn about Authorator product. Articles span the what it does, to the why it does it and the how to do it. - that's a lot.
                    </p>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Grid className="articleListWidth" style={{ marginTop: "20px", borderTop: "solid 1px #AAAAAA" }}>
              {fillList()}
            </Grid>

          </Container>
          <div id="right-area" className='articleSidebar-outside-container'>
            <ArticleSlider artItemsList={articleList} />
          </div>
        </div >
        {AuthStdFooter()}
      </>
    )
  }
  return (<>{articlePage()}</>)

} 